import { injectReducer } from 'store/reducers'

export default (store) => ({
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TeamListContainer',
      './modules/teamList'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TeamList = require('./containers/TeamListContainer').default
      const actions = require('./modules/teamList')
      const reducer = require('./modules/teamList').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'teamList', reducer: reducer })

      store.dispatch(actions.fetchTeams())
      /*  Return getComponent   */
      cb(null, TeamList)

    /* Webpack named bundle   */
    }, 'teamList')
  }
})



// WEBPACK FOOTER //
// ./src/routes/TeamList/index.js